/**
 * Pure helpers for the ticket rail's Details panel: which statuses the Status
 * select offers, and the "Received via" line. The API is the authority — the
 * allowed set comes from its state machine (`detail.allowedTransitions`).
 */

/** Resolve and reopen have their own dialogs; closing is the system's. */
const DEDICATED = new Set(['resolved', 'closed'])

/**
 * The Status select's targets: the API's `allowedTransitions` minus resolved /
 * closed. Empty (no select) for a customer, a terminal ticket, or an API that
 * sent none.
 */
export function statusTargets(allowed: readonly string[] | null | undefined, current: string): string[] {
  return [...new Set(allowed ?? [])].filter((s) => s !== current && !DEDICATED.has(s))
}

/** "21 Oct 2026, 07:55" in the viewer's zone; null for a missing or malformed instant. */
export function formatReceivedAt(iso: string | null | undefined, timeZone: string): string | null {
  if (!iso) return null
  const at = Date.parse(iso)
  if (!Number.isFinite(at)) return null
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short', timeZone }).format(at)
}
